<template>
  <v-btn-toggle v-model="language" mandatory>
    <v-btn small v-for="lang in configs.languageKeys" :value="lang" :key="lang" @click="selectLang(lang)">
      {{ $t(`lang.${lang}`) }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import {mapState} from "vuex";
export default {
  name: 'LanguageSelector',
  data() {
    return {
      language: localStorage.getItem('lang'),
    };
  },
  computed: {
    ...mapState({
      configs: (state) => state.configs,
    }),
  },
  methods: {
    selectLang(lang) {
      console.log('selectLang ' + lang);
      localStorage.setItem('lang',lang);
      this.$store.dispatch('language/loadLanguage', { lang });
    },
  },
};
</script>
